import { CurrencyPipe, DatePipe, NgClass, CommonModule, NgFor, NgIf } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { ApexOptions, NgApexchartsModule } from 'ng-apexcharts';
import { Subject, Subscription, switchMap, takeUntil, tap } from 'rxjs';
import { MatSelectModule } from '@angular/material/select';
import { FormControl, Validators } from '@angular/forms';
// import { UntypedFormControl } from '@angular/forms';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Store } from '@ngrx/store';
import { AppState, selectUtilsState } from 'app/store/app.states';
import { MostrarExcepcion, MostrarSpinner, OcultarSpinner } from 'app/store/actions/utils.action';
import { CoalService } from 'app/services/coal.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { EmpresaService } from 'app/layout/layouts/vertical/classy/empresa-service.service';

enum Period {
    CurrentMonth,
    PreviousMonth,
    CurrentYear,
    PreviousYear
}

interface DataItem {
    nombre: string;
    sumaTotal: number;
}
interface ApexChartData {
    series: number[];
    labels: string[];
}


@Component({
    selector: 'app-tablero',
    templateUrl: './tablero.component.html',
    styleUrls: ['./tablero.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatButtonModule, MatIconModule, MatMenuModule, MatDividerModule, NgApexchartsModule, MatTableModule, MatSortModule, NgClass, MatProgressBarModule, CurrencyPipe, DatePipe, CommonModule, NgFor, NgIf, MatSelectModule, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule]
})
export class TableroComponent implements OnInit {
    byInvoiceType: ApexOptions;
    byProduct: ApexOptions;

    public chartOptions: ApexOptions;
    public chartOptionsTaxes: ApexOptions;

    searchInputControl = new FormControl('');
    spinner: boolean;
    invoiceTotal: number = 0;

    // searchInputControl: UntypedFormControl = new UntypedFormControl();

    Period = Period; // Esto lo hace accesible en la plantilla
    selectedPeriod: Period | null = 0;
    selectedColor: string = '';
    startDate: Date | null = null;
    endDate: Date | null = null;
    idEmpresa: any;
    objetoGridConfiguration: any;
    resumen = {
        folios: 0,
        usados: 0,
        vencidos: 0,
        disponibles: 0,
        porcentaje: 0
    }
    porcentajesTotales: {
        activas: number;
        canceladas: number;
    };
    showBar: boolean = false;
    dataPorComprobante: any;
    dataPorCliente: any;
    dataPorProducto: any;

    busquedaGeneral = new FormControl('', [Validators.required]);
    frmDocumento = new FormControl(0);
    tipoComprobante: any;
    verGrafica: boolean;
    verImagenRegistroFacturas: boolean;
    dataTaxes: any;

    frmAnio = new FormControl(0);
    anios: any = [];
    meses: any;
    frmMes = new FormControl(0);

    empresaSeleccionada: any;
    empresaSubscription: Subscription;
    fechaFiltro: string;
    configured: boolean = null;

    constructor(
        private readonly store: Store<AppState>,
        private srvcoal: CoalService,
        private changeDetectorRef: ChangeDetectorRef,
        private _snackBar: MatSnackBar,
        private route: Router,
        private empresaService: EmpresaService
    ) {

    }

    ngOnInit(): void {
        this.store.select(selectUtilsState).subscribe((state: any) => {
            if (state.empresaSeleccionada === undefined) {
				this.configured = false;
				throw new Error('Empresa no configurada. Proceso interrumpido.');
			}
			else {
				this.configured = true;
                if (this.idEmpresa !== state.empresaSeleccionada.id) {
                    this.idEmpresa = state.empresaSeleccionada.id;
                }
            }
        });

        this.porcentajesTotales = {
            activas: 0,
            canceladas: 0
        };
        this.GetAnios();
        this.setPeriod(0);
        this.getFolios();
        this.GetTipoCOmprobante();
        
        // Suscribirse al servicio para recibir notificaciones sobre cambios en la empresa seleccionada
        this.empresaSubscription = this.empresaService.empresaSeleccionada$.subscribe(empresa => {
            if (empresa) {
                this.empresaSeleccionada = empresa;
                console.log('Ya llegamos al tablero', empresa);

                // Deja que Angular termine de procesar el cambio antes de recargar los datos
                setTimeout(() => {
                    this.reloadData();
                }, 0);
            }
        });
    }

    reloadData() {
        console.log('Empresa seleccionada en reloadData:', this.empresaSeleccionada);
        this.getInvoiceTotal();
        this.getInvoiceStatus();
        this.getByTypeInvoice();
        this.getByCustomer();
        this.getByProducts();
        this.getActiveCancel();
        this.getTaxes();
    }

    getInvoiceTotal() {
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];


        this.srvcoal.getService(`fac-facturas/invoice-total?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            this.invoiceTotal = res.data.attributes.sumatoriaTotal;
            this.changeDetectorRef.detectChanges();
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });
    }

    getInvoiceStatus() {
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];

        this.srvcoal.getService(`fac-facturas/cancelvsactives?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            this.porcentajesTotales = res.data.attributes
            this.changeDetectorRef.detectChanges();
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });
    }

    getFolios() {
        this.store.dispatch(MostrarSpinner());
        this.srvcoal.getService(`ope-empresas?filters[id]=${this.idEmpresa}&populate=ope_empresa_paquetes.ope_empresa_paquete_hs.cat_paquete_estatus`)
            .subscribe((res: any) => {
                this.store.dispatch(OcultarSpinner());
                this.objetoGridConfiguration = res.data[0]?.attributes?.ope_empresa_paquetes?.data;
                this.calculateFolios();
            }, (error: any) => {
                this.store.dispatch(OcultarSpinner());
                error?.error?.error?.status === 400 ?
                    this._snackBar.open(
                        error?.error?.error?.message,
                        'OK',
                        { duration: 5000 }
                    ) :
                    this._snackBar.open(
                        'Algo salió mal. Por favor, vuelva a intentarlo.',
                        'OK',
                        { duration: 5000 }
                    );
            });
    }

    calculateFolios() {
        let folios = this.objetoGridConfiguration;

        let activeFolios = folios.filter(function (paquete) {
            return this.indexOf(paquete?.attributes?.ope_empresa_paquete_hs?.data[0]?.attributes?.cat_paquete_estatus?.data?.attributes?.paqueteEstatus) < 0;
        }, ['Cancelado', 'Solicitud enviada']);
        let total = activeFolios.map(item => item.attributes?.folios).reduce((a, b) => a + b, 0);

        this.resumen.folios = total;
        this.resumen.vencidos = 0;
        this.resumen.usados = activeFolios.map(item => item.attributes?.usado).reduce((a, b) => a + b, 0);
        this.resumen.disponibles = total - this.resumen.usados;
        this.resumen.porcentaje = (this.resumen.usados / this.resumen.folios) * 100;
        this.showBar = true;
        this.changeDetectorRef.detectChanges();
    }

    getByTypeInvoice() {
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];

        this.srvcoal.getService(`fac-facturas/porcomprobante?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            this.dataPorComprobante = res.data.attributes.results
            this.configByInvoice()
            // this.porcentajesTotales = res.data.attributes
            this.changeDetectorRef.detectChanges();
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });
    }

    getByCustomer() {
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];

        this.srvcoal.getService(`fac-facturas/topcustomer?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            this.dataPorCliente = res.data.attributes.results
            this.changeDetectorRef.detectChanges();
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });
    }

    getByProducts() {
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];

        this.srvcoal.getService(`fac-facturas/byproductos?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            this.dataPorProducto = res.data.attributes.results;
            this.dataPorProducto = res.data.attributes.results.map(item => ({
                ...item,
                sumaTotal: item.sumaTotal || 0  // Reemplaza null por 0
            }));
            this.configByProduct();
            this.changeDetectorRef.detectChanges();
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });
    }

    getTaxes() {
        this.store.dispatch(MostrarSpinner());
        this.spinner = true;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];

        this.srvcoal.getService(`fac-facturas/getTaxes?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            console.log('getTaxes', res);
            this.dataTaxes = res.data.attributes;
            this.configTaxes();
            this.changeDetectorRef.detectChanges();
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });
    }

    configByInvoice() {
        const dataForChart = this.transformDataForApexChart(this.dataPorComprobante);


        this.byInvoiceType = {
            chart: {
                animations: {
                    speed: 400,
                    animateGradually: {
                        enabled: false,
                    },
                },
                fontFamily: 'inherit',
                foreColor: 'inherit',
                height: '220px',
                type: 'pie',
                sparkline: {
                    enabled: true,
                },
                events: {
                    // Evento de clic en una rebanada de la gráfica
                    dataPointSelection: (event, chartContext, config) => {
                        const dataPointIndex = config.dataPointIndex;
                        const tipoSeleccionado = this.dataPorComprobante[dataPointIndex]
                        const tipoComprobante = this.tipoComprobante.filter((f: any) => f.attributes.nombre == tipoSeleccionado.nombre)[0]
                        this.verDetalle(tipoComprobante.id, '2', null, '0')
                    }
                }
            },
            colors: ["#1B4893", "#4681DE", "#00A9E6", "#4EC6E1", "#A627CB", "#96E4FF", "#787FF6"],
            labels: dataForChart.labels,
            dataLabels: {
                enabled: true,
                distributed: true, // Esto asegurará que cada etiqueta se muestre en su respectiva rebanada
                formatter: function (val, opts) {
                    return opts.w.config.labels[opts.seriesIndex]
                },
                style: {
                    fontSize: '12px', // Puedes ajustar el tamaño de la fuente según sea necesario
                    fontFamily: 'Helvetica, Arial, sans-serif', // Y la fuente si es necesario
                    colors: ['#fff'] // Color de la fuente, ajustar según corresponda
                },
                dropShadow: {
                    enabled: true,
                    top: 1,
                    left: 1,
                    blur: 1,
                    color: '#000',
                    opacity: 0.45
                }
            },
            plotOptions: {
                pie: {
                    customScale: 0.9,
                    expandOnClick: true,
                    donut: {
                        size: '70%',
                    },
                },
            },
            series: dataForChart.series,
            states: {
                hover: {
                    filter: {
                        type: 'none',
                    },
                },
                active: {
                    filter: {
                        type: 'none',
                    },
                },
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                theme: 'dark',
                custom: ({
                    seriesIndex,
                    w,
                }): string => {
                    const formatter = new Intl.NumberFormat('es-MX', {
                        style: 'currency',
                        currency: 'MXN',
                        minimumFractionDigits: 2,
                    });
                    const formattedValue = formatter.format(w.config.series[seriesIndex]);

                    return `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                <div class="ml-2 text-md font-bold leading-none">${formattedValue}</div>
                            </div>`;
                },
            },
        };
    }

    configByProduct() {
        const dataForChart = this.transformDataForApexChart(this.dataPorProducto);

        this.byProduct = {
            series: dataForChart.series,
            chart: {
                animations: {
                    speed: 400,
                    animateGradually: {
                        enabled: false,
                    },
                },
                fontFamily: 'inherit',
                foreColor: 'inherit',
                width: 550,
                type: 'donut'
            },
            labels: dataForChart.labels,
            dataLabels: {
                enabled: true,
                distributed: true, // Esto asegurará que cada etiqueta se muestre en su respectiva rebanada
                formatter: function (val, opts) {
                    const formatter = new Intl.NumberFormat('es-MX', {
                        style: 'currency',
                        currency: 'MXN',
                        minimumFractionDigits: 2,
                    });
                    const formattedValue = formatter.format(opts.w.config.series[opts.seriesIndex]);

                    return formattedValue
                },
                style: {
                    fontSize: '12px', // Puedes ajustar el tamaño de la fuente según sea necesario
                    fontFamily: 'Helvetica, Arial, sans-serif', // Y la fuente si es necesario
                    colors: ['#fff'] // Color de la fuente, ajustar según corresponda
                },
                dropShadow: {
                    enabled: true,
                    top: 1,
                    left: 1,
                    blur: 1,
                    color: '#000',
                    opacity: 0.45
                }
            },
            colors: ["#1B4893", "#4681DE", "#00A9E6", "#4EC6E1", "#A627CB", "#96E4FF", "#787FF6"],
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: "bottom"
                        }
                    }
                }
            ]
        };
    }

    configActiveCancel({ chartData, meses }) {

        let facturaData = meses.map(mes => chartData.Factura[mes] || 0);
        let notaCreditoData = meses.map(mes => chartData['Nota de Credito'][mes] || 0);
        let canceladasData = meses.map(mes => chartData.Cancelada[mes] || 0);


        this.chartOptions = {
            series: [
                {
                    name: "Factura",
                    type: "column",
                    data: facturaData
                },
                {
                    name: "Nota de crédito",
                    type: "column",
                    data: notaCreditoData
                },
                {
                    name: "Canceladas",
                    type: "column",
                    data: canceladasData
                }
            ],
            colors: ["#1B4893", "#4681DE", "#00A9E6", "#4EC6E1", "#A627CB", "#96E4FF", "#787FF6"],
            chart: {
                height: 350,
                type: "line",
                stacked: false,
                events: {
                    dataPointSelection: (event, chartContext, config) => {
                        const tipo = this.onDataPointSelected(config.seriesIndex, config.dataPointIndex);
                        let tipoComprobante = '0'
                        let estatus = '2'

                        if (tipo == 'Factura') {
                            tipoComprobante = '1'
                        }
                        if (tipo == 'Nota de credito') {
                            tipoComprobante = '2'
                        }
                        if (tipo == 'Cancelada') {
                            estatus = '3'
                        }

                        const mesSeleccionado = meses[config.dataPointIndex];
                        const anio = this.endDate.getFullYear();

                        this.route.navigateByUrl(`/factura/facturas/${anio}/${mesSeleccionado}/0/0/${tipoComprobante}/${estatus}/0/0`);
                    }
                }
            },
            dataLabels: {
                enabled: false
            },

            xaxis: {
                categories: meses
            },
            tooltip: {
                fixed: {
                    enabled: true,
                    position: "topLeft", // topRight, topLeft, bottomRight, bottomLeft
                    offsetY: 30,
                    offsetX: 60
                }
            },
            legend: {
                horizontalAlign: "left",
                offsetX: 40
            }
        };

        this.verGrafica = true;
    }

    configTaxes() {
        this.chartOptionsTaxes = {
            series: this.transformarImpuestosASeries(this.dataTaxes.grafica),
            chart: {
                type: "bar",
                height: 150,
                stacked: true
            },
            colors: ["#1B4893", "#4681DE", "#00A9E6", "#4EC6E1", "#A627CB", "#96E4FF", "#787FF6"], dataLabels: {
                enabled: true,
                formatter: function (val) {
                    // Asegúrate de que val sea un número para evitar errores de formato
                    return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(val));
                }
            },
            plotOptions: {
                bar: {
                    horizontal: true
                }
            },
            stroke: {
                width: 1,
                colors: ["#fff"]
            },
            xaxis: {
                categories: ['Impuestos'],
                labels: {
                    formatter: function (val) {
                        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(Number(val));
                    }
                }
            },
            yaxis: {
                title: {
                    text: undefined
                }
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val);
                    }
                }
            },
            fill: {
                opacity: 1
            },
            legend: {
                position: "top",
                horizontalAlign: "left",
                offsetX: 40
            }
        };

        this.verGrafica = true;
    }

    onDataPointSelected(seriesIndex, dataPointIndex) {
        const seriesNames = ["Factura", "Nota de credito", "Cancelada"];
        return seriesNames[seriesIndex]
    }

    setPeriod(period: Period): void {
        this.selectedPeriod = period;
        this.selectedColor = 'primary'; // You could also use a map to assign different colors to different periods if needed
        const now = new Date();

        switch (period) {
            case Period.CurrentMonth:
                this.startDate = new Date(now.getFullYear(), now.getMonth(), 1);
                this.endDate = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                break;
            case Period.PreviousMonth:
                this.startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                this.endDate = new Date(now.getFullYear(), now.getMonth(), 0);
                break;
            case Period.CurrentYear:
                this.startDate = new Date(now.getFullYear(), 0, 1);
                this.endDate = new Date(now.getFullYear(), 11, 31);
                break;
            case Period.PreviousYear:
                this.startDate = new Date(now.getFullYear() - 1, 0, 1);
                this.endDate = new Date(now.getFullYear() - 1, 11, 31);
                break;
        }

        const months = [
            "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", 
            "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
        ];
        
        const startYear = this.startDate.getFullYear();
        const startMonth = this.startDate.getMonth(); // No sumamos 1 porque el índice de months ya lo maneja
        
        this.fechaFiltro = ( period >= 2 ) ? `${startYear}` : `${months[startMonth]} ${startYear}`;
        

        console.log(`Año: ${startYear}, Mes: ${startMonth}`);

        this.reloadData();
    }

    transformDataForApexChart(dataItems: DataItem[]): ApexChartData {
        const series = dataItems.map(item => item.sumaTotal);
        const labels = dataItems.map(item => item.nombre);

        return { series, labels };
    }

    searchGeneral() {
        if (!this.busquedaGeneral.hasError('required')) {
            this.route.navigateByUrl(`/factura/facturas/0/0/0/0/0/0/0/${this.busquedaGeneral.value}`);
        }
    }

    GetTipoCOmprobante() {
        this.srvcoal.getService(`cat-tipo-comprobantes?populate=*&filters[portal][$eq]=true`).subscribe((res: any) => {
            if (res.err) {
                console.log("erro *************** 1")
            } else if (res.excepcion) {
                console.log("erro *************** 2")
            } else {
                this.tipoComprobante = res.data
            }
        }, (error: any) => {
            console.log("erro *************** 3", error)
        });
    }

    onSelectionChangeTipoComprobante(e: any) {
        this.route.navigateByUrl(`/factura/nueva/${e.value}`);
    }

    getActiveCancel() {
        this.store.dispatch(MostrarSpinner());
        this.verGrafica = false;
        this.spinner = true;
        this.verImagenRegistroFacturas = false;

        const start = this.startDate.toISOString().split('T')[0];
        const end = this.endDate.toISOString().split('T')[0];

        this.srvcoal.getService(`fac-facturas/getActiveCancel?idEmpresa=${this.idEmpresa}&startDate=${start}T00:00:01&endDate=${end}T23:59:59`).subscribe((res: any) => {
            const data = res.data.attributes.results;
            if (data.length > 0) {
                const processedData = this.processDataForChart(data);
                console.log('## Data de facturas por mes', processedData);
                
                this.configActiveCancel(processedData);
            } else {
                this.verGrafica = true;
                this.verImagenRegistroFacturas = true;
            }
            this.store.dispatch(OcultarSpinner());
        }, (error: any) => {
            console.log("error ***************", error);
            this.store.dispatch(OcultarSpinner());
        });

    }

    processDataForChart(data) {
        let chartData = {
            Factura: {},
            'Nota de Credito': {},
            Cancelada: {}
        };

        let minMesNumerico = 12; // Mes más temprano en el año
        let maxMesNumerico = 1;

        // Llenar los datos
        data.forEach(item => {
            minMesNumerico = Math.min(minMesNumerico, item.mesNumerico);
            maxMesNumerico = Math.max(maxMesNumerico, item.mesNumerico);

            if (item.estatus !== 'Cancelada') {
                if (!chartData[item.tipoComprobanteNombre][item.nombreMes]) {
                    chartData[item.tipoComprobanteNombre][item.nombreMes] = 0;


                }
                chartData[item.tipoComprobanteNombre][item.nombreMes] += parseInt(item.total);
            } else {

                if (!chartData[item.estatus][item.nombreMes]) {
                    chartData[item.estatus][item.nombreMes] = 0;

                }

                chartData[item.estatus][item.nombreMes] += parseInt(item.total);
            }

        });

        let meses = [];
        for (let i = minMesNumerico; i <= maxMesNumerico; i++) {
            meses.push(this.getMesNombre(i));
        }

        // Asegurar que todos los meses estén presentes en cada categoría
        meses.forEach(mes => {
            if (!chartData.Factura[mes]) chartData.Factura[mes] = 0;
            if (!chartData['Nota de Credito'][mes]) chartData['Nota de Credito'][mes] = 0;
            if (!chartData.Cancelada[mes]) chartData.Cancelada[mes] = 0;
        });

        return { chartData, meses };
    }

    getMesNombre(mesNumerico) {
        const nombresMeses = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
        return nombresMeses[mesNumerico - 1];
    }

    verDetalle(tipoComprobante: string, estatus: string, ruta: string, rfc: string) {

        if (ruta) {
            this.route.navigateByUrl(ruta);
            return
        }
        const now = new Date();
        let date
        let anio = '0'
        let mesSeleccionado = '0'

        const monthNames = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        switch (this.selectedPeriod) {
            case Period.CurrentMonth:
                date = new Date(now.getFullYear(), now.getMonth(), 1);
                anio = date.getFullYear();
                mesSeleccionado = monthNames[date.getMonth()]
                break;
            case Period.PreviousMonth:
                date = new Date(now.getFullYear(), now.getMonth() - 1, 1);
                anio = date.getFullYear();
                mesSeleccionado = monthNames[date.getMonth()]
                break;
            case Period.CurrentYear:
                date = new Date(now.getFullYear(), 0, 1);
                anio = date.getFullYear();
                break;
            case Period.PreviousYear:
                date = new Date(now.getFullYear() - 1, 0, 1);
                anio = date.getFullYear();
                break;

        }

        console.log(anio)
        console.log(mesSeleccionado)
        this.route.navigateByUrl(`/factura/facturas/${anio}/${mesSeleccionado}/${rfc}/0/${tipoComprobante}/${estatus}/0/0`);
    }

    sumarTotalesTaxes(arr) {
        return arr.reduce((acumulador, objetoActual) => acumulador + objetoActual.total, 0);
    }

    transformarImpuestosASeries(impuestos) {
        // Mapear el arreglo de impuestos a la estructura deseada para las series
        const series = impuestos.map(impuesto => {
            return {
                name: impuesto.impuesto,
                data: [impuesto.total]
            };
        });

        // Devolver el arreglo de series transformado
        return series;
    }

    onYearChange(event: any) {
        const selectedYear = event.value;
        // Asegúrate de que los nombres de los meses estén en el idioma que prefieras.
        const monthNames = [
            'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
            'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];

        this.srvcoal.getService(`fac-facturas/distinct-months?year=${selectedYear}&idEmpresa=${this.idEmpresa}`).subscribe((res: any) => {
            // Realiza las operaciones con los datos recibidos aquí
            this.meses = res.data.attributes.months.map((monthNumber: number) => monthNames[monthNumber - 1]);
        }, (error: any) => {
            console.error("Error al obtener los datos:", error);
        });
    }

    GetAnios() {
        this.srvcoal.getService(`fac-facturas/distinct-years?idEmpresa=${this.idEmpresa}`).subscribe((res: any) => {
            this.anios = res.data.attributes.years;
        }, (error: any) => {
            console.log("error ***************", error);
        });
    }

    openSlide() {
        let anio = this.frmAnio.value;
        let mesNombre: any = this.frmMes.value;

        // Crear un mapa para convertir el nombre del mes a un número
        let mesMap = {
            "Enero": 1, "Febrero": 2, "Marzo": 3, "Abril": 4, "Mayo": 5,
            "Junio": 6, "Julio": 7, "Agosto": 8, "Septiembre": 9,
            "Octubre": 10, "Noviembre": 11, "Diciembre": 12
        };

        let numeroMes = mesMap[mesNombre];

        if (numeroMes) {
            this.startDate = new Date(anio, numeroMes - 1, 1);

            this.endDate = new Date(anio, numeroMes, 0);
        } else if (mesNombre === "todos") {
            this.startDate = new Date(anio, 0, 1);
            this.endDate = new Date(anio, 11, 31);
        }


        this.reloadData()
    }

}
